<template>
  <div>
    <div class="search-wrap" style="margin-top: 5px">
      <div class="spacing">
        <el-input size="mini" placeholder="公司名称"  clearable v-model="self_where.task_id" style="width: 200px"></el-input>
      </div>
      <div class="spacing">
        <el-select size="mini" v-model="self_where.master_id" filterable clearable placeholder="请选择相关流程">
          <el-option v-for="item in masterList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="spacing">
        <el-button size="mini" type="primary" @click="search">搜索</el-button>
      </div>
      <div class="spacing">
        <el-button size="mini" type="success" @click="showSettingBox">新增</el-button>
      </div>
    </div>
    <div class="table-wrap" style="width: 100%">
      <el-table :data="pageData.list" style="width: 100%">
        <el-table-column prop="name" label="公司名称" width="400"></el-table-column>
        <el-table-column prop="master_name" label="相关流程" width=""></el-table-column>
<!--        <el-table-column prop="setting" label="配置" width=""></el-table-column>-->
        <el-table-column prop="status" label="状态" width="">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status" type="success">正常</el-tag>
            <el-tag v-if="!scope.row.status" type="danger">禁用</el-tag>
          </template>
        </el-table-column>
        <template>
          <el-table-column label="操作" width="">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="editShowSettingBox(scope.row)">修改</el-button>
              <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <!--配置-->
    <el-dialog title="配置" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
      <el-input type="hidden" v-model="boxData.cid" />
      <el-descriptions title="" :column="2" border>
        <el-descriptions-item label="公司名称" labelStyle="width: 150px">
          <el-input size="mini" v-model="boxData.name"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="相关流程" labelStyle="width: 150px">
          <el-select size="mini" v-model="boxData.master_id" filterable placeholder="请选择相关流程">
            <el-option v-for="item in masterList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="配置" labelStyle="width: 150px">
          <el-table :data="boxData.setting" style="width: 100%">
            <el-table-column label="参数名" prop="key">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.key"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="参数值" prop="value">
              <template slot-scope="scope">
                <el-input size="mini" v-model="scope.row.value"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="right">
              <template slot="header" slot-scope="scope">
                <el-button size="mini" type="success" @click="addSetting">添加</el-button>
              </template>
              <template slot-scope="scope">
                <el-button size="mini" @click="delSetting(scope)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>

    </el-dialog>
  </div>

</template>

<script>

import FlowTimeoutLog from "./components/FlowTimeoutLog";
import Http from "./common/Http";
import moment from "moment/moment";
import selectPersonnel from "../Personnel/components/selectPersonnel";

export default {
  name:"CompanySetting",
  components: {FlowTimeoutLog, selectPersonnel},
  data () {
    return {
      loading: false,
      dialogVisible:false,
      masterList: [],
      pageData:{
        list:[],
        total:0,
        pageSize:10,
        page:1
      },
      self_where: {},
      boxData: {
        setting : []
      },

    }
  },
  created() {
    this.getList()
    this.getMasterList()
    this.oa_user_id = window.localStorage.getItem('oa_user_id');
  },
  mounted() {
  },
  methods: {
    search() {
      this.pageData.page = 1
      this.getList()
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      let that = this;
      Http.get("flow/FlowCompanySetting/getSettingList",{
        where:JSON.stringify(that.self_where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData = res.data
        }
      })
    },
    getMasterList() {
      const that = this;
      let searchWhere = {page : 1, page_size : 1000};
      Http.get("flow/FlowMaster/getList",searchWhere,res=>{
        if(res.code) {
          that.masterList = res.data.list
        } else {
          that.masterList = {}
        }
      })
    },
    showSettingBox() {
      this.dialogVisible = true
      this.boxData = {}
      this.boxData.setting = []
    },
    editShowSettingBox(item) {
      this.dialogVisible = true
      this.boxData = {}
      this.boxData = item;
    },
    addSetting() {
      this.boxData.setting.push({'key' : "", 'value' : ""})
    },
    delSetting(scope) {
      this.boxData.setting.splice(scope.$index, 1)
    },
    submit() {
      let that = this
      Http.post("flow/FlowCompanySetting/saveSetting",this.boxData,res=>{
        that.dialogVisible = false
        if(res.code) {
          that.$message({
            message: '操作成功',
            type: 'success'
          });
        } else {
          that.$message({
            message: res.msg,
            type: 'error'
          });
        }
        this.getList()
      })
    }

  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 200px );
  overflow-x: scroll;
}
.spacing {
  display: inline-block;
  margin-right: 10px;
  margin-top: 10px;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  //background: #99a9bf;
}
.bg-purple {
  //background: #d3dce6;
}
.bg-purple-light {
  //background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 80px;
}
.border {
  border: 1px solid #e8e8e8;
}
.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}
.button-table {
  color: #1867c0;
  cursor: pointer;
  display: inline-block;
  margin-left: 15px
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/CompanySetting.vue